import { cancelRequestConstructor } from '@monorepo/deals';
import { CancelClaimService } from 'order_ts/v1/order_web/cancel_claim_web_pb_service';

const getCancelList = (filter: object | null) =>
  cancelRequestConstructor(filter, CancelClaimService.ListCancelClaim);

export default getCancelList;
